/* Taylor Electrical Solutions — CONDUIT global JS (RX-5 / Project 215) */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* chrome = announcement + header, so hero/emergency land fully framed */
  function measureChrome() {
    var h = 0;
    var ann = document.querySelector('.te-ann');
    var hdr = document.querySelector('.section-header');
    if (ann) h += ann.getBoundingClientRect().height;
    if (hdr) h += hdr.getBoundingClientRect().height;
    if (h > 0) root.style.setProperty('--te-chrome', Math.round(h) + 'px');
  }

  /* run width for the current pulse */
  function sizeRuns(scope) {
    (scope || document).querySelectorAll('.te-run').forEach(function (r) {
      r.style.setProperty('--te-runw', Math.round(r.getBoundingClientRect().width) + 'px');
    });
  }

  /* ---- conduit charge: an SVG path traced along the centreline of the two
         conductors, measured from the rendered ::before/::after, so the pulse
         turns the rounded bend and runs down the drop instead of leaving the run ---- */
  function tracePath(run) {
    var svg = run.querySelector('.te-run__svg');
    var path = svg && svg.querySelector('.te-run__zap');
    if (!path) return null;
    var W = run.clientWidth;
    var b = getComputedStyle(run, '::before'), a = getComputedStyle(run, '::after');
    var left = run.classList.contains('te-run--l');
    var H = parseFloat(b.height) || 56;
    var rule = parseFloat(b.borderTopWidth) || 2;
    var yOut = rule / 2, yIn = (parseFloat(a.top) || 7) + rule / 2;
    var rOut = parseFloat(left ? b.borderTopLeftRadius : b.borderTopRightRadius) - rule / 2;
    var rIn = parseFloat(left ? a.borderTopLeftRadius : a.borderTopRightRadius) - rule / 2;
    var xOut, xIn;
    if (left) { xOut = parseFloat(b.left) + rule / 2; xIn = parseFloat(a.left) + rule / 2; }
    else { xOut = W - parseFloat(b.right) - rule / 2; xIn = W - parseFloat(a.right) - rule / 2; }
    var ym = (yOut + yIn) / 2, xm = (xOut + xIn) / 2, r = Math.max(2, (rOut + rIn) / 2);
    var f = function (n) { return Math.round(n * 10) / 10; };
    var d = left
      ? 'M' + f(W) + ' ' + f(ym) + ' H' + f(xm + r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 0 ' + f(xm) + ' ' + f(ym + r) + ' V' + f(H)
      : 'M0 ' + f(ym) + ' H' + f(xm - r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + f(xm) + ' ' + f(ym + r) + ' V' + f(H);
    svg.setAttribute('width', W); svg.setAttribute('height', H);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    path.setAttribute('d', d);
    return path;
  }

  function charge(run) {
    if (RM || run.getAttribute('data-te-charged')) return;
    var path = tracePath(run);
    if (!path || !path.animate || !path.getTotalLength) return;
    var L = path.getTotalLength();
    if (!L) return;
    run.setAttribute('data-te-charged', '1');
    var seg = Math.max(48, Math.min(120, L * 0.12));
    path.style.strokeDasharray = seg + ' ' + (L + seg);
    path.animate([
      { strokeDashoffset: seg + 'px', opacity: 0, offset: 0 },
      { opacity: 1, offset: 0.06 },
      { opacity: 1, offset: 0.9 },
      { strokeDashoffset: (-L) + 'px', opacity: 0, offset: 1 }
    ], { duration: Math.min(2600, Math.max(1500, L * 1.5)), delay: 850, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'both' });
  }

  /* ---- fail-open reveal system (RX-5 §8.11) ---- */
  var SEL = 'h1,h2,h3,p,li,.te-btn,.te-card,.te-frame,.te-circuit,.te-node,.te-fact,.te-door,.te-plate,.te-alert,.te-live,.te-em__card,.te-chips';
  var EXCLUDE = '.section-header,#te-loader,.te-ann,.te-tick,.menu-drawer';
  var io = null;
  /* runs start fully clipped (draw-in), and Chrome's IntersectionObserver measures the
     clipped (zero) area — so a run is triggered by its visible next sibling instead */
  var runFor = typeof WeakMap === 'function' ? new WeakMap() : null;

  function reveal(el) {
    el.classList.add('te-in');
    if (el.classList.contains('te-run')) charge(el);
  }

  function collect(scope) {
    var found = [];
    (scope || document).querySelectorAll('.te-sec').forEach(function (sec) {
      if (!/\bte-/.test(sec.className)) return;
      sec.querySelectorAll(SEL).forEach(function (el) {
        if (el.closest(EXCLUDE)) return;
        if (el.classList.contains('te-in')) return;
        found.push(el);
      });
    });
    var kept = [];
    found.forEach(function (el) {
      if (!kept.some(function (k) { return k.contains(el); })) kept.push(el);
    });
    var counts = new Map();
    kept.forEach(function (el) {
      var p = el.parentElement, i = counts.get(p) || 0;
      counts.set(p, i + 1);
      el.style.setProperty('--te-d', Math.min(i, 7) * 70 + 'ms');
    });
    return kept;
  }

  function init(scope, immediate) {
    var els = collect(scope);
    var runs = Array.prototype.slice.call((scope || document).querySelectorAll('.te-run'));
    sizeRuns(scope);
    if (RM || !('IntersectionObserver' in window) || immediate) {
      els.forEach(reveal);
      runs.forEach(reveal);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var runs = runFor && runFor.get(e.target);
          if (runs) { runs.forEach(reveal); runFor.delete(e.target); }
          if (e.target.classList.contains('te-rv')) reveal(e.target);
          io.unobserve(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { el.classList.add('te-rv'); io.observe(el); });
    runs.forEach(function (el) {
      var trigger = el.nextElementSibling;
      while (trigger && trigger.classList.contains('te-run')) trigger = trigger.nextElementSibling;
      trigger = trigger || el.parentElement;
      if (!runFor || !trigger) { reveal(el); return; }
      el.classList.add('te-rvr');
      var list = runFor.get(trigger) || [];
      list.push(el); runFor.set(trigger, list);
      io.observe(trigger);
    });
  }

  /* failsafe sweep — nothing can stay hidden */
  function sweep() {
    document.querySelectorAll('.te-rv:not(.te-in),.te-rvr:not(.te-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.2) reveal(el);
    });
  }

  /* ---- hero photo rotation ---- */
  function rotInit(scope) {
    if (RM) return;
    (scope || document).querySelectorAll('[data-te-rotate]').forEach(function (box) {
      if (box._teRot) return;
      var slides = box.querySelectorAll('.te-slide');
      if (slides.length < 2) return;
      var secs = Math.max(4, Math.min(10, parseInt(box.getAttribute('data-te-rotate'), 10) || 6));
      var i = 0, paused = false;
      function show(n) {
        slides.forEach(function (s, k) {
          var on = k === n;
          s.classList.toggle('is-on', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
      }
      var id = setInterval(function () {
        if (!box.isConnected) { clearInterval(id); return; }
        if (paused || document.hidden) return;
        i = (i + 1) % slides.length; show(i);
      }, secs * 1000);
      box._teRot = id;
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
    });
  }

  /* ---- booking form helpers ---- */
  function formInit(scope) {
    (scope || document).querySelectorAll('[data-te-book]').forEach(function (form) {
      var date = form.querySelector('input[type="date"]');
      if (date) {
        var d = new Date(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
        date.min = d.getFullYear() + '-' + m + '-' + day;
      }
      var sel = form.querySelector('select[data-te-service]');
      if (sel) {
        try {
          var want = new URLSearchParams(window.location.search).get('service');
          if (want) {
            Array.prototype.forEach.call(sel.options, function (o) {
              if (o.value.toLowerCase() === want.toLowerCase()) sel.value = o.value;
            });
          }
        } catch (e) {}
      }
    });
  }

  function boot() {
    measureChrome();
    init(document, !!(window.Shopify && window.Shopify.designMode));
    formInit(document);
    rotInit(document);
    setTimeout(sweep, 3500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('load', measureChrome);
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      measureChrome(); sizeRuns(document);
      document.querySelectorAll('.te-run').forEach(tracePath);
    }, 150);
  });

  /* theme editor: re-init and reveal immediately */
  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target || document;
      init(t, true);
      formInit(t);
      rotInit(t);
      measureChrome();
    });
  });
})();
